import styled from "styled-components";
import { Button as ButtonBase, Space } from "antd";

export const PageTitle = styled.div`
  font-size: 24px;
`;

export const Button = styled(ButtonBase)`
  padding: 0;
`;

export const PageHeader = styled(Space)`
  width: 100%;
  margin-bottom: 0.5em;
`;
